import { render, staticRenderFns } from "./RewardFee.vue?vue&type=template&id=42555236"
import script from "./RewardFee.vue?vue&type=script&lang=js"
export * from "./RewardFee.vue?vue&type=script&lang=js"
import style0 from "./RewardFee.vue?vue&type=style&index=0&id=42555236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports